import type { Dispatch } from 'redux';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { connect } from '@atlassian/jira-react-redux';
import {
	deleteRuleAction,
	setShowDeleteDialogAction,
} from '../../../../../state/actions/rule/delete';
import { isDeleteDialogOpen, isDeleting } from '../../../../../state/selectors/summary';
import type { State } from '../../../../../state/types';
import DeleteDialog from './view';

type OwnProps = {
	ruleSetId: string;
};

const mapStateToProps = (state: State, ownProps: OwnProps) => ({
	isOpen: isDeleteDialogOpen(state, ownProps.ruleSetId),
	isDeleting: isDeleting(state, ownProps.ruleSetId),
});

const mapDispatchToProps = (dispatch: Dispatch, ownProps: OwnProps) => ({
	onDelete: (analyticsEvent: UIAnalyticsEvent) =>
		dispatch(deleteRuleAction(ownProps.ruleSetId, analyticsEvent)),
	onCancel: () => dispatch(setShowDeleteDialogAction(null)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteDialog);
